import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

// router
import { BrowserRouter as Router } from 'react-router-dom';

// style
// import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './components/DoctorCard/DoctorCard.scss';
// sentry.io logging
import { initSentry } from './lib/errorLib';
import App from './App';

const urlParams = new URLSearchParams(window.location.search);
const platform = urlParams.get('platform');

initSentry(platform);

// root
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <App />
  </Router>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
